import React from 'react';
import { Payment } from '../types/booking.types';

interface PaymentsTabProps {
  payments: Payment[];
  onAddPayment: () => void;
}

const PaymentsTab: React.FC<PaymentsTabProps> = ({ payments, onAddPayment }) => {
  const getText = (value: unknown) =>
    value === null || value === undefined || value === '' ? 'N/A' : String(value);

  const getStatusColor = (status: string): string => {
    switch (status?.toLowerCase()) {
      case 'completed':
      case 'success':
      case 'paid':
        return 'bg-green-100 text-green-700';
      case 'pending':
      case 'processing':
        return 'bg-yellow-100 text-yellow-700';
      case 'failed':
      case 'cancelled':
      case 'canceled':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800 flex items-center">
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Payments Received
        </h3>
        <button
          className="bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition-all text-sm font-medium"
          onClick={onAddPayment}
        >
          + Add Payment
        </button>
      </div>
      <div className="overflow-x-auto bg-white border border-gray-200 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">#</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Amount</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Method</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Gateway</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Status</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Transaction ID</th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-700">Date</th>
            </tr>
          </thead>
          <tbody>
            {payments.length > 0 ? (
              payments.map((payment, index) => {
                const status = (payment as any).payment_status ?? (payment as any).status;
                const transactionId =
                  (payment as any).transaction_id ??
                  (payment as any).gateway_payment_id;
                const createdAt = (payment as any).created_at ?? (payment as any).paid_at;
                const method =
                  (payment as any).payment_method ??
                  (payment as any).method;
                const gateway = (payment as any).payment_gateway;

                return (
                  <tr className="border-b border-gray-100 hover:bg-gray-50" key={payment.id}>
                    <td className="py-3 px-4 font-semibold text-gray-700">{index + 1}</td>
                    <td className="py-3 px-4 font-bold text-gray-800">
                      Rs {parseFloat(String((payment as any).amount ?? 0)).toFixed(2)}
                    </td>
                    <td className="py-3 px-4 text-gray-700">{getText(method)}</td>
                    <td className="py-3 px-4 text-gray-700">{getText(gateway)}</td>
                    <td className="py-3 px-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                          String(status ?? '')
                        )}`}
                      >
                        {getText(status)}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-gray-700">{getText(transactionId)}</td>
                    <td className="py-3 px-4 text-gray-600">
                      {createdAt ? new Date(createdAt).toLocaleDateString() : 'N/A'}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="py-8 text-center text-gray-500">
                  No payments found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentsTab;
